import { Table, TableRow, TableCell, TableBody } from '@mui/material';
import { useStyles } from './styles/ReportTableChart.styles';

export const ReportTableChart = ({ title, rows }: { title: string; rows: (string | number)[][] }) => {
    const classes = useStyles();

    return (
        <Table className={classes.tableContainer}>
            <TableBody>
                <TableRow>
                    <TableCell colSpan={2} align={'center'} className={classes.heading}>
                        {title}
                    </TableCell>
                </TableRow>
                {rows.map((row, idx) => (
                    <TableRow key={`chart - ${idx}`} className={classes.tableRow}>
                        {row.map((item, rowIdx) => (
                            <TableCell key={`chart - ${idx} - ${rowIdx}`} sx={{ color: '#696b6e' }}>
                                {item}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
